const HTTP_REGEX = /^https?:\/\//i;

// ensure http(s) is added to the start of the URL
export const normalizeUrlWithHttp = (
  value: any,
  ensureHttps: boolean = false
) => {
  if (!value) return value;
  // contains http(s) so leave it
  if (value.search(HTTP_REGEX) !== -1) {
    return value;
  } else {
    // doesn't contain http(s) at the start so add it
    return `http${ensureHttps ? 's' : ''}://${value}`;
  }
};

export const normalizeHttpUrl = (value: any) =>
  normalizeUrlWithHttp(value, false);

export const normalizeHttpsUrl = (value: any) =>
  normalizeUrlWithHttp(value, true);
